import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

// App has no landing page: any route outside register/user/** must fall through to Keycloak login.
export const authRedirectGuard: CanActivateFn = () => {
	const authService = inject(AuthService);
	authService.login();
	return false;
};
